import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DOMPurify from "dompurify";
import Slider from "../../Components/Slider";

const Singlepageproperty = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
 

  useEffect(() => {
    axios
      .get("https://baseapis.akari.sa/api/Property/GetPropertyById")
      .then((res) => setPost(res.data))
      .catch((err) => setError("Failed to load property"));
  }, [id]);

  if (error) return <div>{error}</div>;
  if (!post) return <div>Loading...</div>;

  return (
    <div className="singlePage">
    <div className="details">
      <div className="wrapper">
        <Slider images={post.images} />
        <div className="info">
          <div className="top">
            <div className="post">
              <h1>{post.title}</h1>
              <div className="address">
                <img src="/pin.png" alt="" />
                <span>{post.address}</span>
              </div>
              <div className="price">$ {post.price}</div>
            </div>
            <div className="user">
              <img src={post.user.avatar} alt="" />
              <span>{post.user.username}</span>
            </div>
          </div>
          <div
            className="bottom"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(post.postDetail.desc),
            }}
          ></div>
        </div>
      </div>
    </div>
    <div className="features">
      <div className="wrapper">
        <p className="title">General</p>
        <div className="listVertical">
          <div className="feature">
            <img src="/utility.png" alt="" />
            <div className="featureText">
              <span>Utilities</span>
              {post.postDetail.utilities === "owner" ? (
                <p>Owner is responsible</p>
              ) : (
                <p>Tenant is responsible</p>
              )}
            </div>
          </div>
          <div className="feature">
            <img src="/pet.png" alt="" />
            <div className="featureText">
              <span>Pet Policy</span>
              {post.postDetail.pet === "allowed" ? (
                <p>Pets Allowed</p>
              ) : (
                <p>Pets not Allowed</p>
              )}
            </div>
          </div>
          <div className="feature">
            <img src="/fee.png" alt="" />
            <div className="featureText">
              <span>Income Policy</span>
              <p>{post.postDetail.income}</p>
            </div>
          </div>
        </div>
        <p className="title">Sizes</p>
        <div className="sizes">
          <div className="size">
            <img src="/size.png" alt="" />
            <span>{post.postDetail.size} sqft</span>
          </div>
          <div className="size">
            <img src="/bed.png" alt="" />
            <span>{post.bedroom} beds</span>
          </div>
          <div className="size">
            <img src="/bath.png" alt="" />
            <span>{post.bathroom} bathroom</span>
          </div>
        </div>
        <p className="title">Nearby Places</p>
        <div className="listHorizontal">
          <div className="feature">
            <img src="/school.png" alt="" />
            <div className="featureText">
              <span>School</span>
              <p>
                {post.postDetail.school > 999
                  ? post.postDetail.school / 1000 + "km"
                  : post.postDetail.school + "m"}{" "}
                away
              </p>
            </div>
          </div>
          <div className="feature">
            <img src="/pet.png" alt="" />
            <div className="featureText">
              <span>Bus Stop</span>
              <p>{post.postDetail.bus}m away</p>
            </div>
          </div>
          <div className="feature">
            <img src="/fee.png" alt="" />
            <div className="featureText">
              <span>Restaurant</span>
              <p>{post.postDetail.restaurant}m away</p>
            </div>
          </div>
        </div>
       
        <div className="buttons">
          <button>
            <img src="/chat.png" alt="" />
            Send a Message
          </button>
          {/*<button
            onClick={handleSave}
            style={{
              backgroundColor: saved ? "#fece51" : "white",
            }}
          >
          
          </button>*/}
        </div>
      </div>
    </div>
  </div>
  );
};

export default Singlepageproperty;
